import { MessageInterface } from './../interfaces/MessageInterface';
import Api from "../services/Api"
import history from '../helpers/history';
import { WalkI } from '../interfaces/Walk';

const api = Api.getInstance()

export const sendMessageWalk = (messageType: number, recipientId: number, text: string, json: string) => {
  const data: MessageInterface = {
    recipientId: recipientId,
    text: text,
    json: json,
    messageType: messageType,
    reportedDate: null,
    version: 'message',
    read: false
  }

  api.post('send_message', data).then(result => {
    result.json().then(resultJson => {
      if (resultJson.status === 'ok') {
        // console.log(resultJson)
      }
    });
  });
}

export const openChat = (id: number) => {
  history.push({
    pathname: '/walk/chat/' + id,
    state: id
  })
}

export const openProfile = (id: number) => {
  history.push({
    pathname: '/walk/user/profile' + id,
    state: id
  })
}

export const sendReminderInChat = (id: number, walk: WalkI) => {
  // send a reminder to a user
  const messageType = 4
  const text = ''
  const json =`{ "date": "${walk.start}", "accepted": null, "createdWalk": true, "walkID": ${walk.id}, "deletedWalk": false }`

  sendMessageWalk(messageType, id, text, json)
}

export const shareWalkInChat = (id: number, walk: WalkI) => {
  // share a created walk with someone
  const messageType = 5
  const text = ''
  const json =`{ "date": "${walk.start}", "accepted": null, "createdWalk": true, "walkID": ${walk.id}, "deletedWalk": false }`

  sendMessageWalk(messageType, id, text, json)
}